export const getAllChildren = (layersArr: any[]) => {
  const layers: any[] = [];

  const pullLayers = (layersArr: any[]) => {
    layersArr.forEach((item: any) => {
      if ('children' in item) {
        return pullLayers(item.children!);
      } else {
        layers.push(item);
      }
    });
  };
  pullLayers(layersArr);

  return layers;
};
